import React, { useState, useRef, useMemo } from "react";
import { useDrag } from "react-dnd";

import { Popover } from "@mui/material";
import { withStyles } from '@mui/styles';
import DragIcon from '@mui/icons-material/DragIndicator';
import UiPidsConstructorStyles from "../UiPidsConstructorStyles";
import CommonStyles from "../../../../common/CommonStyles";
import PredicateChain from "../../../../common/PredicateChain";
import UiRendererSettings from "../../../../common/UiRendererSettings";

import { getLastRstData } from "../../../../utils";

const styles = {
  style: {
    margin: '1px',
    fontSize: '11px',
    color: '#4c4c4c',
    padding: "0 5px",
    backgroundColor: "white",
  },
  ...CommonStyles,
  ...UiPidsConstructorStyles,
};

const Component = ({ data, path, classes, setup_rbox_light, ancestor, isForm, handleHtmlChange, handleRendererChange }) => {
  const [renderSettingOpened, setRenderSettingOpened] = useState(false);
  const ref = useRef(null);
  const rendernRef = useRef(null);

  const [{ isDragging }, drag, preview] = useDrag({
    type: data.type,
    item: { id: data.id, pids: data.pids, value: data.value, path },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
  });

  const closeRendererPopover = () => {
    setRenderSettingOpened(false)
  };

  const opacity = isDragging ? 0 : 1;
  const outline = isDragging ? '1px solid #347CFF' : '1px dashed #B9BBCD';
  drag(ref);

  const component = { ...data };

  let rstData;
  if (component && component.pids)
  rstData = useMemo(() => getLastRstData(component.pids, ancestor, setup_rbox_light), [component.pids, ancestor]);
  const isBoolean = rstData && rstData.primitive === "_bool";

  return (
    <div
      id={data.id}
      ref={preview}
      style={{ opacity }}
      className={`${classes.component} "component draggable" ${classes.alignCenter}`}
    >
      <div ref={ref} className={`${classes.alignCenter}`} style={{ cursor: "move" }}>
        <DragIcon className={`drag-handle-icon ${classes.dragHandle}`} />
      </div>
      {component && component.type === 'text' ? (
        <textarea
          type="text"
          value={data.value || ''}
          className={classes.resizableTextarea}
          onChange={(e) => {
            handleHtmlChange(path, data.id, e.target.value);
          }}
        />
      ) : (
        <div className={`${classes.style} ${classes.alignCenter}`} style={{ outline }}>
          <span className={`${classes.mr5}`}>{`${component && component.type}`}</span>
          <div style={{ width: '100%' }}>
            <PredicateChain
              mode="view"
              showType={true}
              rst={component.pids}
              ancestor={ancestor}
            />
          </div>

          {isBoolean && component.type === 'value' ?
            <React.Fragment>
              <div
                ref={rendernRef}
                className={`${classes.mr5} ${classes.pointer}`}
                onClick={() => setRenderSettingOpened(true)}
              >
                <strong
                  style={{
                    padding: '3px',
                    color: component.renderer ? '#347CFF' : '9EA1BE',
                  }}
                > R
                </strong>
              </div>
              <Popover
                id={`render-popover-${data.id}`}
                anchorEl={rendernRef.current}
                open={renderSettingOpened}
                onClose={closeRendererPopover}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <UiRendererSettings
                  data={data}
                  path={path}
                  isForm={isForm}
                  classes={classes}
                  component={component}
                  handleRendererChange={handleRendererChange}
                />
              </Popover>
            </React.Fragment>
          : null}
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(Component);
